export default {
    REVIEW_STATUSES: {
        SENT: 'Sent',
        REVIEWED: 'Reviewed',
    },
    TRIP_STATUSES: {
        CONFIRMED: 'Confirmed',
        QUOTE: 'Quote',
        CANCELLED: 'Cancelled',
        HELD: 'Held',
        PAST: 'Past',
    },
};



// WEBPACK FOOTER //
// ./src/app/modules/trip/config/trip.constant.js